/*
 * @FileName: æ°æ®è§åéªè¯ï¼ è¿åå¸å°å¼
 * @Author: linkun.he
 * @Date: 2019-01-16 20:14:00
 */
import {
  adressRe,
  allCharacterRe,
  alphabetRe,
  blankTrimRe,
  cardRe,
  chineseRe,
  commaNumberRe,
  dateLineRe,
  decimalFractionRe,
  digitsNumberRe,
  domainRe,
  emailRe,
  ExtractionRe,
  figuresNumberRe,
  ipRe,
  languageNumberRe,
  legalityCountRe,
  noLanguageNumberRe,
  numberRe,
  phoneRe,
  postalCodeRe,
  pwdStrengthRe,
  shortIdCardRe,
  sizeNumberRe,
  specialCharacterRe,
  tencentNumberRe,
  teplphoneRe,
  twoDecimalPlacesRe,
  webRe,
} from './regex';

export function isEmptyInputValue(value: any): boolean {
  // we don't check for string here so it also works with arrays
  return value == null || value.length === 0;
}

/** æ¯å¦ä¸ºæ°å­ */
export function isNum(value: string | number): boolean {
  return numberRe.test(value.toString());
}

/** æ¯å¦ä¸ºæ´æ° */
export function isInt(value: string | number): boolean {
  // tslint:disable-next-line:triple-equals
  return isNum(value) && parseInt(value.toString(), 10) == value;
}

/** æ¯å¦ä¸ºå°æ° */
export function isDecimal(value: string): boolean {
  return decimalFractionRe.test(value);
}

/** æ¯å¦ä¸ºèº«ä»½è¯ */
export function isIdCard(value: string | number): boolean {
  return typeof value === 'string' && cardRe.test(value);
}

/** æ¯å¦ä¸ºææºå· */
export function isMobile(value: string | number): boolean {
  return typeof value === 'string' && phoneRe.test(value);
}

/** æ¯å¦URLå°å */
export function isUrl(url: string): boolean {
  return adressRe.test(url);
}

/** æ¯å¦ä¸ºemail */
export function isEmail(value: string): boolean {
  return emailRe.test(value);
}

/** éé¶å¼å¤´çæå¤å¸¦ä¸¤ä½å°æ°çæ°å­ */
export function isTwoDecimal(value: number): boolean {
  return twoDecimalPlacesRe.test(value.toString());
}

/** ä¸­æãè±æãæ°å­åæ¬ä¸åçº¿ï¼ */
export function isLanguage(value: string): boolean {
  return languageNumberRe.test(value);
}

/** ä¸­æãè±æãæ°å­ä½ä¸åæ¬ä¸åçº¿ç­ç¬¦å· */
export function isNoLanguage(value: string): boolean {
  return noLanguageNumberRe.test(value);
}

/** è±æåæ°å­ */
export function isFigures(value: string): boolean {
  return figuresNumberRe.test(value);
}

/** åå */
export function isDomain(value: string): boolean {
  return domainRe.test(value);
}

/** å½åçµè¯å·ç  */
export function isTeplphone(value: string): boolean {
  return teplphoneRe.test(value);
}

/** ç­èº«ä»½è¯å·ç (æ°å­ãå­æ¯xç»å°¾) */
export function isShort(value: string): boolean {
  return shortIdCardRe.test(value);
}

/** å¸å·æ¯å¦åæ³(å­æ¯å¼å¤´ï¼åè®¸5-16å­èï¼åè®¸å­æ¯æ°å­ä¸åçº¿) */
export function isLegality(value: string): boolean {
  return legalityCountRe.test(value);
}

/** å¼ºå¯ç (å¿é¡»åå«å¤§å°åå­æ¯åæ°å­çç»åï¼ä¸è½ä½¿ç¨ç¹æ®å­ç¬¦ï¼é¿åº¦å¨8-10ä¹é´) */
export function isStrongCipher(value: string): boolean {
  return pwdStrengthRe.test(value);
}

/** ç¹æ®å­ç¬¦ */
export function isSpecialCharacter(value: string): boolean {
  return !specialCharacterRe.test(value);
}

/** ä¸­å½é®æ¿ç¼ç ï¼[1-9]\d{5}(?!\d) (ä¸­å½é®æ¿ç¼ç ä¸º6ä½æ°å­) */
export function isPostal(value: number | string): boolean {
  return postalCodeRe.test(value.toString());
}

/** æåColor Hex  Codes */
export function isExtraction(value: string): boolean {
  return ExtractionRe.test(value);
}

/** é¿åº¦ä¸º3-20çææå­ç¬¦ */
export function isAllCharacter(value: string): boolean {
  return allCharacterRe.test(value);
}

/**  5-18ä½çæ°å­ï¼ */
export function isDigits(value: number): boolean {
  return digitsNumberRe.test(value.toString());
}

/** ä¸ºæ±å­ */
export function isChinese(value: string): boolean {
  return chineseRe.test(value);
}

/** ç±26ä¸ªè±æå­æ¯ç»æçå­ç¬¦ä¸² */
export function isLetters(value: string): boolean {
  return alphabetRe.test(value);
}

/** è¾è®¯QQå· */
export function isTencent(value: number): boolean {
  return tencentNumberRe.test(value.toString());
}

/** æ°å­å¨15-200ä¹é´ */
export function isSize(value: number): boolean {
  return sizeNumberRe.test(value.toString());
}

/** *é¦å°¾ç©ºç½å­ç¬¦çæ­£åè¡¨è¾¾å¼ */
export function isBlank(value: string): boolean {
  return blankTrimRe.test(value);
}

/** *éªè¯è´§å¸å¯ä»¥å¸¦éå·æèä¸ºå¸¦åç¬¦å· */
export function isComma(value: string): boolean {
  return commaNumberRe.test(value);
}

/** æ¥æ */
export function isdateline(value: string): boolean {
  return dateLineRe.test(value);
}

/** ç½å */
export function isWebRe(value: string): boolean {
  return webRe.test(value);
}

/** ipå°å */
export function isIpRe(value: string): boolean {
  return ipRe.test(value);
}
